import { useCallback, useEffect, useState } from 'react';
import { fetchAnnouncementPriorities } from './actions';
import { AnnouncementPrioritiesReturnType, IAnnouncementPriority } from './types';

export function useAnnouncementPriorities(
	getOnRender: boolean | undefined = undefined
): AnnouncementPrioritiesReturnType {
	const [data, setData] = useState<IAnnouncementPriority[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	const getPriorities = useCallback(async () => {
		try {
			setLoading(true);
			const response = await fetchAnnouncementPriorities();
			setData(response);
			return response;
		} catch {
			return [];
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		if (getOnRender) {
			getPriorities();
		}
	}, [getOnRender, getPriorities]);

	return { data, loading, getPriorities };
}
